import { Box, Typography } from '@mui/material';
import { UserWithoutRolesWrapper } from '@styles/Layout/LayoutStyles';
import { muiTheme }        from '@styles/muiTheme';

export const UserWithoutRoles = () => (
  <UserWithoutRolesWrapper>
    <Box
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant='h1' color={muiTheme.palette.error.main}>You are not authorized to view this page</Typography>
    </Box>
  </UserWithoutRolesWrapper>
);
